import { getEnv } from "@ace/env";

export type ModalStatus = {
  showModal: boolean;
};

/**
 * Sets the modal status to shown and returns state if modal should be displayed
 *
 * @param token
 * @param modalName
 * @returns ModalStatus
 */
const registerModalAsSeenByUser = async (
  token: string,
  modalName: string,
): Promise<ModalStatus> => {
  const headers = {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
  };

  const body = {
    modal: modalName,
  };

  const response = await fetch(
    `${getEnv("VITE_ACE_WEB_AUTH_SERVER")}/modal-shown`,
    {
      method: "POST",
      headers,
      body: JSON.stringify(body),
    },
  );
  const json = await response.json();

  if (json.status === "ERROR") {
    throw new Error(json.error[0].msg);
  }

  const data = json.data as ModalStatus;

  return data;
};

export { registerModalAsSeenByUser };
